import { useState } from "react";

import { MetadataDashboardTemplate } from "../../../components/Templates/MetadataDashboardTemplate";
import PageHeader from "../../../components/UI/PageHeader";
import { TabsSwitcher } from "../../../components/UI/TabsSwitcher";
import { useScopeParams } from "@/hooks/useScopeParams";

export default function ProtocolDeviations() {
  const { id } = useScopeParams();

  const tabItems = [
    {
      label: "Participants",
      key: "protocol_deviations_subjects",
      constants: {
        wikiLink: "/wiki/guides/exploration-sites-protocol-deviations",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/protocol-deviations`,
      },
    },
    {
      label: "Sites",
      key: "protocol_deviations_sites",
      constants: {
        wikiLink: "/wiki/guides/exploration-sites-protocol-deviations",
        idLink: undefined,
      },
    },
    {
      label: "Study",
      key: "protocol_deviations_study",
      constants: {
        wikiLink: "/wiki/guides/exploration-sites-protocol-deviations",
        idLink: undefined,
      },
    },
  ];

  const [activeTab, setActiveTab] = useState(tabItems[0]);
  return (
    <div className="w-full p-4">
      <div className="flex justify-between mb-4">
        <div className="flex gap-2">
          <PageHeader
            title="Sites: Protocol Deviations"
            tooltipText="Review study protocol deviations as determined by CRAs."
            dataTestId="protocol-deviations-page-header-info-tooltip"
          />
        </div>
        <div className="flex items-center">
          <TabsSwitcher
            tabItems={tabItems}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>
      <MetadataDashboardTemplate
        type={activeTab.key}
        constants={activeTab.constants}
        subjectId={undefined}
      />
    </div>
  );
}
